<template>
  <div class='form-flow'>
    <div class="YTitle titel">{{dataValue.title}} <el-button v-if="dataValue.add && data.controls.compile" @click="addFrom" class="btn" size="medium" type="primary" round>{{dataValue.btnTitle}}</el-button></div>
    <el-form class="from-warp" :model="formInline" ref="rules" :inline="true" v-for="(itemWarp, index) in formInline.fromList" :key="index" :style="style" :disabled='!data.controls.compile' :label-width='`${ 200 / 192 }rem`'>
      <span class="from" v-for="(item, index2) in itemWarp" :key="item.id">
        <div v-if="item.type === 'Title' || item.type === 'TooltipText' || item.type === 'Divider' || item.type === 'Form'">
          <component v-bind:is="item.type" :data='item'></component>
        </div>
        <el-form-item
          class="from-item"
          :label="`${item.controls.title}：`"
          v-show="item.controls.show"
          :prop='`fromList.${index}.${index2}.controls.value`'
          :rules="rules(item)"
          v-else>
          <component v-bind:is="item.type" :data='getItem(item, index)' @changeControls='changeControls'></component>
        </el-form-item>
        <br v-if="item.controls.br" />
      </span>
      <el-button v-if="formInline.fromList.length > 1" @click="remove(itemWarp,index)" class="delete" type="danger" icon="el-icon-delete" circle></el-button>
    </el-form>
  </div>
</template>

<script>
import deepClone from '@/shared/utils/deep-clone'
export default {
  name: 'FormFlow',

  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      formInline: {
        fromList: []
      }
    }
  },

  computed: {
    style () {
      const obj = {}
      if (this.data.controls.border) {
        obj.border = `${1 / 192}rem solid #dbe3ef`
        obj.padding = `${20 / 192}rem`
        obj.margin = `${20 / 192}rem`
      }
      return obj
    },

    dataValue () { return deepClone(this.data).controls }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      if (this.data.controls.fromList) {
        this.formInline.fromList = deepClone(this.data.controls.fromList)
      } else {
        this.formInline.fromList = deepClone([this.data.controls.controlList])
      }
    },

    rules (item) {
      this.validate = (rule, value, callback) => {
        if (item.controls.verify && !new RegExp(item.controls.verify).test(value)) {
          callback(new Error('输入格式错误，请重新输入'))
        } else {
          callback()
        }
      }
      return [
        { required: true, message: `${item.controls.text ? item.controls.text : '请选择或填写该选项'}`, trigger: 'blur' },
        { validator: this.validate, trigger: 'blur' }
      ]
    },

    getItem (item, index) {
      item.index = index
      return item
    },

    addFrom () {
      this.formInline.fromList.push(deepClone(this.data.controls.controlList))
    },

    remove (item, index) {
      this.formInline.fromList.splice(index, 1)
    },

    changeControls (val) {
      this.formInline.fromList[val.index].forEach((res, index) => {
        if (val.id === res.id) {
          res.controls.value = val.controls.value
        }
      })
      const obj = deepClone(this.data)
      obj.controls.fromList = deepClone(this.formInline.fromList)
      this.$emit('change', obj)
    },

    submitForm () {
      const obj = []
      this.$refs.rules.forEach((res, index) => {
        obj[`${index}`] = new Promise((resolve, reject) => {
          res.validate(valid => {
            if (valid) resolve()
          })
        })
      })
      return obj
    }
  }
}
</script>

<style lang='stylus' scoped>
  .form-flow
    display flex
    flex-direction column
    position relative
    .titel
      display flex
      align-items center
      .btn
        margin-left 20px
        position absolute
        right 20px
    .from-warp
      position relative
      .delete
        position absolute
        bottom 20px
        right 20px
      .from
        .from-item
          margin-right 100px
</style>
